import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";
import { logError } from "./lib/errorLogger";
import "./index.css";

const sentryEnable = Boolean(import.meta.env.VITE_SENTRY_ENABLE ?? false);
const sentryDsn = String(import.meta.env.VITE_SENTRY_DSN ?? "").trim();
const mode = String(import.meta.env.MODE ?? "").toLowerCase();
const isDevLike = mode === "development" || mode === "dev" || mode === "test";
const tracesSampleRate = Number(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? (isDevLike ? 0.05 : 0.2),
);
const profilesSampleRate = 0;
const replaySessionSampleRate = Number(
  import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE ?? (isDevLike ? 0.0 : 0.1),
);
const replayOnErrorSampleRate = Number(
  import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE ?? (isDevLike ? 0.2 : 1.0),
);

// Sentry.init({
//   dsn: sentryDsn,
//   environment: import.meta.env.MODE,
//   // Enable Sentry only when DSN is configured
//   enabled: sentryDsn.length > 0,
//   // Error Monitoring + Tracing + Application Metrics
//   tracesSampleRate,
//   profilesSampleRate,
//   // Logs
//   enableLogs: sentryEnable,
//   integrations: [
//     // Performance tracing
//     Sentry.browserTracingIntegration(),
//     // Capture console logs as Sentry events/breadcrumbs
//     Sentry.captureConsoleIntegration({ levels: ["log", "warn", "error"] }),
//     // Session Replay
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   // Replay sampling
//   replaysSessionSampleRate: replaySessionSampleRate,
//   replaysOnErrorSampleRate: replayOnErrorSampleRate,
// });

// Catch unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
  logError({
    message: event.reason?.message ?? String(event.reason),
    stack: event.reason?.stack,
    module: "unhandledrejection",
    severity: "error",
  });
});

// Catch uncaught errors
window.addEventListener("error", (event) => {
  logError({
    message: event.message,
    stack: event.error?.stack,
    module: "window.onerror",
    severity: "error",
  });
});

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);
